import firebase from 'firebase/index';
import {getMarker} from './marker';

const BUCKET_NAME = 'analytics';

function isCollected(key) {
	const {sessionStorage} = window;

	return Object.prototype.hasOwnProperty
		.call(sessionStorage, key);
}

export default function collect(collectionId, fileId) {
	const key = `${collectionId}/${fileId}`;

	if (isCollected(key)) {
		return false;
	}

	const timestamp = Date.now();
	const marker = getMarker();
	const data = {
		collectionId,
		fileId,
		timestamp,
		marker
	};

	return firebase.database()
		.ref(BUCKET_NAME)
		.push(data)
		.then(ref => {
			sessionStorage.setItem(key, 1);
			return ref;
		});
}




// WEBPACK FOOTER //
// ./src/client/services/analytics/collector.js